import { render, staticRenderFns } from "./marketingReason.vue?vue&type=template&id=32f7044d&scoped=true&"
import script from "./marketingReason.vue?vue&type=script&lang=js&"
export * from "./marketingReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7044d",
  null
  
)

component.options.__file = "marketingReason.vue"
export default component.exports